import { ThemeEvents } from '@theme/events';
import { getShippingProfileForVariant, isExpressVariant } from '@theme/shipping-profile-guard';

class ProductShippingOptions extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {CustomEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail?.data?.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const variantId = event.detail?.resource?.id;
    if (!variantId) return;

    this.#updateForVariant(variantId);
    this.#updateShippingProfileInput(variantId);
  };

  /**
   * @param {number | string} variantId
   */
  #updateForVariant(variantId) {
    const isExpress = isExpressVariant(variantId);

    this.querySelector('.product-shipping-options__item--express')?.toggleAttribute('hidden', !isExpress);
    this.querySelector('.product-shipping-options__separate-note')?.toggleAttribute('hidden', !isExpress);
  }

  /**
   * @param {number | string} variantId
   */
  #updateShippingProfileInput(variantId) {
    const section = this.closest('.shopify-section, dialog');
    const shippingProfileInput = section?.querySelector('[name="properties[_shipping_profile]"]');

    if (!shippingProfileInput) return;

    shippingProfileInput.value = getShippingProfileForVariant(variantId);
  }
}

if (!customElements.get('product-shipping-options')) {
  customElements.define('product-shipping-options', ProductShippingOptions);
}
